<div class="modal-backdrop" (click)="onClose(false)"></div>
<div class="add-categorization-modal-container" #modalContainer (click)="$event.stopPropagation()">
  <div class="modal-content">
    <div class="modal-body">
      <div class="modal-left-panel">
        <h4 class="panel-title">Item Type</h4>
        <nav class="navigation-menu">
          <button 
            *ngFor="let option of navigationOptions" 
            class="nav-option"
            [class.active]="selectedView === option.value"
            (click)="selectView(option.value)"
            type="button">
            {{ option.label }}
          </button>
        </nav>
      </div>
      <div class="modal-right-panel">
        <div class="panel-content" [ngSwitch]="selectedView">
          <app-categorization-document-item-view
            *ngSwitchCase="'document-item'"
            [state]="state"
            [row]="row"
            [viewInNativeLanguage]="viewInNativeLanguage"
            [rollupOnly]="isRollupTemplateItem"
            (categorizeSelected)="onDocumentItemCategorize($event)">
          </app-categorization-document-item-view>
          <app-categorization-manual-item-view
            *ngSwitchCase="'manual-item'"
            [state]="state"
            [row]="row"
            (insertItem)="onInsertManualItem()"
          ></app-categorization-manual-item-view>
          <app-categorization-offset-adjustment-view
            *ngSwitchCase="'offset-adjustment'"
            [state]="state"
            [row]="row"
            (insertOffsetAdjustment)="onInsertOffsetAdjustment($event)">
          </app-categorization-offset-adjustment-view>
        </div>
      </div>
    </div>
  </div>
</div>
